import { render } from "./messaging.vue?vue&type=template&id=aca97286"
import script from "./messaging.vue?vue&type=script&lang=js"
export * from "./messaging.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__